/**
 * Customer-facing Tempo capability guide (in-panel MVP).
 * Groups map to gateway / MCP capabilities but never expose tool IDs in the UI.
 */

export interface CopilotGuidanceCapability {
  /** Stable id for accordion expand state. */
  id: string;
  /** i18n key for capability title. */
  titleKey: string;
  /** i18n key for short description. */
  descriptionKey: string;
  /** i18n keys for example prompts (chips that send via facade.send). */
  promptKeys: readonly string[];
}

/** Outcome-oriented capability groups shown in the Tempo guidance panel. */
export const COPILOT_GUIDANCE_CAPABILITIES: readonly CopilotGuidanceCapability[] = [
  {
    id: 'hours',
    titleKey: 'copilot.guidance.capabilities.hours.title',
    descriptionKey: 'copilot.guidance.capabilities.hours.description',
    promptKeys: [
      'copilot.guidance.capabilities.hours.prompt1',
      'copilot.guidance.capabilities.hours.prompt2',
    ],
  },
  {
    id: 'timeline',
    titleKey: 'copilot.guidance.capabilities.timeline.title',
    descriptionKey: 'copilot.guidance.capabilities.timeline.description',
    promptKeys: [
      'copilot.guidance.capabilities.timeline.prompt1',
      'copilot.guidance.capabilities.timeline.prompt2',
    ],
  },
  {
    id: 'team',
    titleKey: 'copilot.guidance.capabilities.team.title',
    descriptionKey: 'copilot.guidance.capabilities.team.description',
    promptKeys: [
      'copilot.guidance.capabilities.team.prompt1',
      'copilot.guidance.capabilities.team.prompt2',
    ],
  },
  {
    id: 'projects',
    titleKey: 'copilot.guidance.capabilities.projects.title',
    descriptionKey: 'copilot.guidance.capabilities.projects.description',
    promptKeys: [
      'copilot.guidance.capabilities.projects.prompt1',
      'copilot.guidance.capabilities.projects.prompt2',
    ],
  },
  {
    id: 'schedules',
    titleKey: 'copilot.guidance.capabilities.schedules.title',
    descriptionKey: 'copilot.guidance.capabilities.schedules.description',
    promptKeys: [
      'copilot.guidance.capabilities.schedules.prompt1',
      'copilot.guidance.capabilities.schedules.prompt2',
    ],
  },
  {
    id: 'meetings',
    titleKey: 'copilot.guidance.capabilities.meetings.title',
    descriptionKey: 'copilot.guidance.capabilities.meetings.description',
    promptKeys: [
      'copilot.guidance.capabilities.meetings.prompt1',
      'copilot.guidance.capabilities.meetings.prompt2',
    ],
  },
  {
    id: 'attention',
    titleKey: 'copilot.guidance.capabilities.attention.title',
    descriptionKey: 'copilot.guidance.capabilities.attention.description',
    promptKeys: [
      'copilot.guidance.capabilities.attention.prompt1',
      'copilot.guidance.capabilities.attention.prompt2',
    ],
  },
  {
    id: 'howto',
    titleKey: 'copilot.guidance.capabilities.howto.title',
    descriptionKey: 'copilot.guidance.capabilities.howto.description',
    promptKeys: [
      'copilot.guidance.capabilities.howto.prompt1',
      'copilot.guidance.capabilities.howto.prompt2',
    ],
  },
] as const;
